import _ from 'lodash';
import { createClient } from '@/shared/api';
import type {
  DevicesForStudyCreationQuery,
  DevicesForStudyCreationQueryVariables,
} from '@/shared/api';
import DEVICES_FOR_STUDY_CREATION_QUERY from '../queries/devicesForStudyCreation';

/**
 * Loads the devices selectable while creating a study. Runs the devices-for-study-creation query with the filter and limit and throws the first GraphQL error only when the callCenterDevices payload is missing.
 *
 * @param filter - Filter selecting the candidate devices.
 * @param limit - Maximum number of devices to load; defaults to 10.
 * @returns A promise resolving to the selectable devices payload.
 */
const fetchDevicesForStudyCreation = async (
  filter: DevicesForStudyCreationQueryVariables['filter'],
  limit = 10,
): Promise<DevicesForStudyCreationQuery['callCenterDevices']> => {
  const client = createClient();
  const result = await client.query<
    DevicesForStudyCreationQuery,
    DevicesForStudyCreationQueryVariables
  >({
    query: DEVICES_FOR_STUDY_CREATION_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = result;
  const { callCenterDevices } = data;
  if (_.isNil(callCenterDevices) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return callCenterDevices;
};

export default fetchDevicesForStudyCreation;
